import Vue from 'vue';

function optionalProperty(obj: any, ...args: string[]) {
    const res = args.reduce((obj, level) => obj && obj[level], obj);
    return res || '';
}

Vue.filter('op', optionalProperty);

export default optionalProperty;
